import { Box } from '@mui/material';
import { TabPanelProps } from './Tabs.props';

export const TabPanel = ({
  children,
  value,
  activeValue,
  keepMounted = false,
  viewportOffset = '300px',
  ...props
}: TabPanelProps) => {
  const isActive = value === activeValue;

  if (!isActive && !keepMounted) {
    return null;
  }

  return (
    <Box
      role="tabpanel"
      hidden={!isActive}
      id={`tabpanel-${value}`}
      aria-labelledby={`tab-${value}`}
      {...props}
      sx={{
        p: 3,
        display: isActive ? 'block' : 'none',
        overflow: 'auto',
        // Subtracts the offset (header + tabs + padding) from viewport height
        maxHeight: `calc(100vh - ${viewportOffset})`,
        ...props.sx,
      }}
    >
      {children}
    </Box>
  );
};

export default TabPanel;
